import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCoin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.72 20.15C-0.57 17.86-0.57 14.14 1.72 11.85L11.85 1.72C14.14-0.57 17.86-0.57 20.15 1.72L30.28 11.85C32.57 14.14 32.57 17.86 30.28 20.15L20.15 30.28C17.86 32.57 14.14 32.57 11.85 30.28L1.72 20.15Z",
		fill: "#ffce80"
	})
});
export default SvgCoin;
